import "./OfferSection.css";

import LaunchOfferCard from "./LaunchOfferCard";
import BonusOfferCard from "./BonusOfferCard";
import PackageCard from "./PackageCard";

import {
    Zap,
    Search,
    TrendingUp,
    Globe,
    Building2,
    ShoppingCart,
    Code2,
    Layers3,
    Cpu
} from "lucide-react";

const OfferSection = () => {

    return (
        <section className="offer-section" id="offers">

            <div className="offer-container">

                {/* =========================
            SPECIAL OFFERS
        ========================= */}

                <span className="offer-tag">
                    SPECIAL OFFERS
                </span>

                <h2 className="offer-heading">
                    Exclusive Launch Offers
                </h2>

                <p className="offer-description">
                    Get your business online with our premium website development
                    packages and exclusive launch bonuses available for a limited time.
                </p>


                {/* MAIN LAUNCH OFFER */}

                <div className="featured-offer">
                    <LaunchOfferCard />
                </div>


                {/* BONUS OFFERS */}

                <div className="bonus-offers">

                    <BonusOfferCard
                        icon={<Zap />}
                        title="Speed Optimization"
                        price="₹5,000"
                        description="Your website is optimized for fast loading, better Core Web Vitals, and a smooth experience across all devices and connection speeds."
                        badge="Optimized Before Launch"
                    />

                    <BonusOfferCard
                        icon={<Search />}
                        title="Website Audit"
                        price="₹3,000"
                        description="A professional audit covering design, performance, SEO, and usability — with detailed, actionable recommendations to improve your website."
                        badge="Included at No Extra Cost"
                    />

                    <BonusOfferCard
                        icon={<TrendingUp />}
                        title="Basic SEO Setup"
                        price="₹7,000"
                        description="Essential on-page SEO, metadata configuration, and search engine-ready structure so your site is discoverable from day one."
                        badge="Search Engine Ready"
                    />

                </div>


                {/* =========================
            PACKAGES
        ========================= */}

                <div className="packages-area">

                    <div className="packages-header">

                        <span className="packages-tag">
                            OUR PACKAGES
                        </span>

                        <h2>
                            Choose The Right Package
                        </h2>

                        <p>
                            Transparent pricing with flexible solutions designed for startups,
                            growing businesses, and enterprises.
                        </p>

                    </div>


                    <div className="packages-grid">

                        {/* STARTER WEBSITE */}

                        <PackageCard
                            icon={<Globe />}
                            title="Starter Website"
                            price="₹22,999"
                            popular={true}
                            description="A professional website for small businesses ready to establish a strong online presence."

                            features={[
                                "Responsive Design",
                                "SEO Ready",
                                "Free SSL",
                                "Mobile Friendly",
                                "Free Deployment"
                            ]}

                            idealFor="Small businesses, startups, professionals, portfolios and local businesses looking to establish their online presence."

                            delivery="7–14 Business Days"

                            details={[
                                "Up to 3 Website Pages",
                                "Free Domain for 3 Year",
                                "Free Hosting for 3 Year",
                                "Responsive Design",
                                "Mobile & Tablet Optimization",
                                "Basic SEO Setup",
                                "SSL Certificate",
                                "Contact Form Integration",
                                "WhatsApp Contact Integration",
                                "Business Email Setup",
                                "Performance Optimization",
                                "Website Deployment"
                            ]}
                        />


                        {/* BUSINESS WEBSITE */}

                        <PackageCard
                            icon={<Building2 />}
                            title="Business Website"
                            price="₹34,999"
                            description="A feature-rich business website designed for growing companies that need more functionality."

                            features={[
                                "Responsive Design",
                                "SEO Ready",
                                "Free SSL",
                                "Admin Panel",
                                "Mobile Friendly",
                                "Free Deployment"
                            ]}

                            idealFor="Growing businesses, agencies, service companies and organizations that need a larger and more functional website."

                            delivery="14–21 Business Days"

                            details={[
                                "Up to 7 Website Pages",
                                "Premium Responsive Design",
                                "Mobile & Tablet Optimization",
                                "Content Management",
                                "Basic Admin Panel",
                                "SEO Setup",
                                "Google Analytics Setup",
                                "Contact Form Integration",
                                "WhatsApp Contact Integration",
                                "Business Email Setup",
                                "SSL Certificate",
                                "Performance Optimization",
                                "Website Deployment"
                            ]}
                        />


                        {/* ECOMMERCE */}

                        <PackageCard
                            icon={<ShoppingCart />}
                            title="eCommerce Website"
                            price="₹49,999"
                            description="A complete online store with payments, product management, orders, and customer management."

                            features={[
                                "Payment Gateway",
                                "Product Catalog",
                                "Admin Panel",
                                "SEO Ready",
                                "Mobile Friendly",
                                "Free SSL"
                            ]}

                            idealFor="Retailers, brands, manufacturers and businesses that want to sell products or services online."

                            delivery="21–30 Business Days"

                            details={[
                                "Complete Online Store",
                                "Product Catalog",
                                "Product & Category Management",
                                "Shopping Cart",
                                "Secure Checkout",
                                "Payment Gateway Integration",
                                "Order Management",
                                "Customer Management",
                                "Admin Dashboard",
                                "Responsive Design",
                                "SEO Setup",
                                "SSL Certificate",
                                "WhatsApp Contact Integration",
                                "Website Deployment"
                            ]}
                        />


                        {/* WEB APPLICATION */}

                        <PackageCard
                            icon={<Code2 />}
                            title="Web Application"
                            price="₹64,999"
                            description="Custom web applications, dashboards and portals built around your business requirements."

                            features={[
                                "User Authentication",
                                "Custom Dashboard",
                                "Database",
                                "API Integration",
                                "Admin Panel",
                                "Cloud Ready"
                            ]}

                            idealFor="Businesses and startups requiring custom dashboards, portals, internal systems or interactive web platforms."

                            delivery="8-12 Weeks"

                            details={[
                                "Custom UI/UX",
                                "User Authentication",
                                "Role-Based Access",
                                "Custom Dashboard",
                                "Database Integration",
                                "Backend Development",
                                "REST API Integration",
                                "Admin Panel",
                                "Responsive Interface",
                                "Security Configuration",
                                "Cloud Deployment",
                                "Performance Optimization"
                            ]}
                        />


                        {/* SOFTWARE / SAAS */}

                        <PackageCard
                            icon={<Layers3 />}
                            title="Software / SaaS"
                            price="₹79,999"
                            description="Custom SaaS platforms, CRM/ERP systems and business automation solutions designed to scale."

                            features={[
                                "Custom CRM/ERP",
                                "Multi-User Auth",
                                "API Development",
                                "Admin Panel",
                                "Cloud Ready",
                                "Free Deployment"
                            ]}

                            idealFor="Startups and businesses building SaaS products, CRM systems, ERP platforms or business automation software."

                            delivery="12-16 Weeks"

                            details={[
                                "Custom Software Architecture",
                                "Multi-User Authentication",
                                "Role & Permission Management",
                                "Custom Admin Dashboard",
                                "Database Architecture",
                                "API Development",
                                "Third-Party Integrations",
                                "CRM / ERP Features",
                                "Cloud Deployment",
                                "Scalable Architecture",
                                "Security Configuration",
                                "Technical Support"
                            ]}
                        />


                        {/* ENTERPRISE */}

                        <PackageCard
                            icon={<Cpu />}
                            title="Enterprise Solution"
                            customPrice={true}
                            description="End-to-end enterprise solutions with custom architecture, integrations and dedicated development support."

                            features={[
                                "Dedicated Team",
                                "Custom Architecture",
                                "Priority Support",
                                "SLA Guarantee",
                                "Cloud Infrastructure",
                                "Monitoring"
                            ]}

                            idealFor="Established businesses and organizations requiring complex systems, integrations and long-term development support."

                            delivery="Based on Project Scope"

                            details={[
                                "Requirement & Technical Consultation",
                                "Custom System Architecture",
                                "Dedicated Development Team",
                                "Enterprise Authentication",
                                "Advanced Admin Systems",
                                "Custom API Development",
                                "Third-Party Integrations",
                                "Cloud Infrastructure",
                                "Scalable Backend Architecture",
                                "Security & Access Control",
                                "Performance Monitoring",
                                "Priority Technical Support"
                            ]}
                        />

                    </div>

                </div>

            </div>

        </section>
    );
};

export default OfferSection;